
import { useState } from "react";
import { useScroll } from "@/hooks/use-scroll";
import { NavMenuItems } from "./navbar/NavMenuItems";
import { NavbarLogo } from "./navbar/NavbarLogo";
import { MobileMenuButton } from "./navbar/MobileMenuButton";
// import { LanguageSelector } from "./navbar/LanguageSelector";
import { useTranslation } from "react-i18next";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const scrolled = useScroll();
  const { i18n } = useTranslation();

  return (
    <nav className={`fixed w-full ${scrolled ? 'bg-[#005da9]/90' : 'bg-[#0077bb]'} transition-colors duration-200 backdrop-blur-md z-50`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <NavbarLogo />
          
          <div className={`hidden md:flex items-center space-x-6 ${i18n.language === 'ar' ? 'space-x-reverse' : ''}`}>
            <NavMenuItems />
            {/* <LanguageSelector /> */}
          </div>

          <div className="md:hidden flex items-center">
            <MobileMenuButton 
              isOpen={isOpen} 
              onClick={() => setIsOpen(!isOpen)} 
            />
          </div>
        </div>

        {isOpen && (
          <div className="md:hidden">
            <div className="pt-2 pb-3 space-y-1">
              <NavMenuItems isMobile />
              {/* <div className="px-3 py-2">
                <LanguageSelector isMobile />
              </div> */}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
